"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorUPLC = void 0;
var bitstream_1 = require("@harmoniclabs/bitstream");
var ErrorUPLC = /** @class */ (function () {
    function ErrorUPLC(msg, addInfos) {
        this.msg = msg;
        this.addInfos = addInfos;
    }
    Object.defineProperty(ErrorUPLC, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("0110");
        },
        enumerable: false,
        configurable: true
    });
    ;
    ErrorUPLC.prototype.clone = function () {
        return new ErrorUPLC(this.msg, this.addInfos);
    };
    return ErrorUPLC;
}());
exports.ErrorUPLC = ErrorUPLC;
